const debugMode = (() => {
  const val = process.env.REACT_APP_DEBUG;
  return val !== undefined && val !== null && Number(val) >= 1;
})();

/**
 * デバッグモード時のみコンソールログを出力する。
 * @param tag   [] 内に表示するタグ文字列（例: 'WS'）
 * @param message ログメッセージ
 * @param args  追加の出力データ
 */
export function debugLog(tag: string, message: string, ...args: unknown[]): void {
  if (!debugMode) return;
  console.log(`[${tag}] ${message}`, ...args);
}

/**
 * デバッグモード時のみ console.warn を出力する。
 */
export function debugWarn(tag: string, message: string, ...args: unknown[]): void {
  if (!debugMode) return;
  console.warn(`[${tag}] ${message}`, ...args);
}

/**
 * デバッグモード時のみ console.error を出力する。
 */
export function debugError(tag: string, message: string, ...args: unknown[]): void {
  if (!debugMode) return;
  console.error(`[${tag}] ${message}`, ...args);
}
